/** @todo добавить ошибки при неправильной передачи параметров, что может привести к ошибкам в это функции */
export default function initGetKey(params) {
    if (params === void 0) { params = 0; }
    if (typeof params === 'number') {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args[params];
        };
    }
    if (typeof params === 'function') {
        return params;
    }
    if (typeof params === 'object') {
        if (params.getKey) {
            return params.getKey;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return args[params.index || 0];
            };
        }
    }
}
